import {
	TOPIC_SETTINGS_ADD_TOPICS,
	TOPIC_SETTINGS_RESET_TOPICS
} from "../../constants";

export const AddTopics = (topics) => {
	return {
		type: TOPIC_SETTINGS_ADD_TOPICS,
		payload: {
			data: {
				topics: topics
			},
		},
	};
};

export const ResetTopics = () => {
	return {
		type: TOPIC_SETTINGS_RESET_TOPICS
	};
};


// WEBPACK FOOTER //
// ./src/api/topics/actions.js